<template>
    <main class="solutions-page" :data-mui-theme="data?.data.theme">
        <SliceZone :components="components" :slices="slices" />
    </main>
</template>
<script lang="ts" setup>
    import {type PrismicDocument} from '@prismicio/types';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from '#app';
    import {createError, definePageMeta, useRoute, useWebsitePageView} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {useDefineSeoAndMetaTags} from '~/composables/useDefineSeoAndMetaTags';
    import {components} from '~/slices/components';

    definePageMeta({
        validate: (): boolean => useFeatureFlag('new-solutions-page').value,
    });

    const route = useRoute();

    const {fetchDocument} = usePrismicDocument('solutions', route.params.uid as string);
    const {data, error} = await useAsyncData<PrismicDocument>('solution-' + route.params.uid, () => fetchDocument());
    if (error.value) {
        throw createError(error.value);
    }

    const {slices} = useABTestSlices(data.value!);

    useDefineSeoAndMetaTags(data.value!);
    useWebsitePageView('cms', 'solutions');
</script>
